/**
 * Image Hero Block Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initImageHeroBlock() {
        const blocks = document.querySelectorAll('.image-hero-block');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] image-hero-block block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initImageHeroBlock);
    } else {
        initImageHeroBlock();
    }
})();